export default __webpack_public_path__ + "static/media/8819.61a3d041.svg";